import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { selectObjects } from "~/misc/common";

export default class extends Controller {
	connect() {
		console.log('initBaGroupForm');
		let last_book_id = $('#ba_group_book_id').myGetNumValue();
		const books = $('#toJs').data('books');
		refresh();
		$('#ba_group_book_id').on('change', refresh);

		function refresh() {
			const book_id = $('#ba_group_book_id').myGetNumValue();
			if (book_id) {
				$('.ba_group_book_count').show(400);
				$('.book').show(400);
				const book = selectObjects(books, 'id', $('#ba_group_book_id').myGetNumValue())[0];
				$('.book .img img').attr("src", book.image_url);
				$('.book .publisher').text(book.publisher_name);
				$('.book .title').text(book.title_w_comment);
				$('.book .codeval').text(book.publisher_code);
				if (!last_book_id) {
					$('#ba_group_book_count').val($('#ba_group_students_count').val()!);
				}
			} else {
				$('.ba_group_book_count').hide(400);
				$('.book').hide(400);
				$('#ba_group_book_count').val('');
			}
			last_book_id = book_id;
		}
	}
}
